export default __webpack_public_path__ + "5b77ec0565359434d6670e6b72a4088b.png";